import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

import { ApiService } from '../../Services/api.service';
import { WebsocketKioskService } from '../../Services/websocket-kiosk.service';

@Component({
  selector: 'app-kiosk',
  imports: [CommonModule, RouterModule],
  templateUrl: './kiosk.component.html',
  styleUrl: './kiosk.component.css'
})
export class KioskComponent {
  production: boolean = environment.production;

  server: any = 'false';
  full_stops: any = 'false';
  version: string = environment.version;
  numberOfLines: any = 7;
  numberOfLinesSchedule: any = 3;
  numberOfFirstLines: number = 1;
  timeToPlay: any = 500;

  noSchedule: boolean = false;
  errorSchedule: boolean = false;
  errorDestinations: boolean = false

  canExit = false;
  conection: boolean = true;
  menu: boolean = true;
  timeStopped: any = 0;
  timeOutToPlay: any;

  currentDate: Date = new Date();
  year: any;
  hour: any;

  destinationList: any = [];
  destinationListToShow: any = [];
  destinationStart: any = 0;
  preSelectedDestination: number = -1;
  selectedDestination: any;
  destinationName: any = '';

  firstLines: any = [];
  lineList: any = [];
  showSchedules: boolean = false;
  pagePreSelected: number = 0;
  page: number = 0;
  numberOfPages: number = 0;

  timeoutModal: any;
  timeoutModalTime: any = 10000;
  @ViewChild('closeModal') closeModal: any;
  
  private translations = [
    {"id":19, "operator": "ANDRADE VOYAGES", "operatorName": "Andrade Voyages"},
    {"id":12, "operator": "ANPIAN", "operatorName": "Anpian"},
    {"id":24, "operator": "AVE MOBILIDADE", "operatorName": "Ave Mobilidade"},
    {"id":1, "operator": "AVIC", "operatorName": "AVIC"},
    {"id":30, "operator": "BARCA EXPRESS", "operatorName": "Barca Express"},
    {"id":17, "operator": "BARQUENSE", "operatorName": "Barquense"},
    {"id":25, "operator": "BLABLACAR", "operatorName": "BlaBlaCar"},
    {"id":4, "operator": "EBA", "operatorName": "Getbus"},
    {"id":5, "operator": "EHGeres", "operatorName": "Hotéis do Gerês"},
    {"id":2, "operator": "FLIXBUS", "operatorName": "FlixBus"},
    {"id":10, "operator": "GETBUS", "operatorName": "GetBus"},
    {"id":27, "operator": "GIPSYY", "operatorName": "Gipsyy"},
    {"id":14, "operator": "GIROMUNDO", "operatorName": "Giromundo"},
    {"id":9, "operator": "INTERNORTE", "operatorName": "Internorte"},
    {"id":20, "operator": "LAZARA", "operatorName": "Lazara"},
    {"id":28, "operator": "MINHO BUS", "operatorName": "Minho Bus"},
    {"id":22, "operator": "MOB. CAVADO", "operatorName": "Cávado Mobilidade"},
    {"id":29, "operator": "MOOVE", "operatorName": "Moove"},
    {"id":8, "operator": "REDM", "operatorName": "Transdev REDM"},
    {"id":3, "operator": "RNE", "operatorName": "Rede Expressos"},
    {"id":13, "operator": "RODOMINHO", "operatorName": "Rodominho"},
    {"id":23, "operator": "TRANSDEV & AVIC", "operatorName": "Transdev & AVIC Lda."},
    {"id":11, "operator": "TRANSDEV NORTE", "operatorName": "Transdev Norte"},
    {"id":16, "operator": "TURISTICO", "operatorName": "Turístico"},
    {"id":7, "operator": "VERDE MINHO", "operatorName": "VerdeMinho"}
  ]

  constructor(
    private api:ApiService,
    private websocketkiosk: WebsocketKioskService,
    private activatedRoute: ActivatedRoute,
  ){}

  ngOnInit(){
    this.checkConection();
    setInterval(() => {
      this.checkConection();
    },30000);

    this.notifyKuma();
    setInterval(() => {
      this.notifyKuma();
    },300000);

    this.currentTime();
    this.reciveMessageWebsocket();
    this.GetParams();

    setInterval(() => {
      this.currentTime();
      this.timeStopped++;
      this.isStopped();
    },1000);
  }

  GetParams(){
    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.server = queryParams.get('server')
    });
  }

  reciveMessageWebsocket(){
    this.websocketkiosk.reciveMessage().subscribe((message: any)=>{
      let type = message.type;
      let press = message.press;
      let button = message.kiosk_button;

      if(type == undefined || press == undefined || button == undefined){
        return;
      }

      if (this.menu){
        
        this.playSound("wand","kiosk_intro");

        this.iniSearch();
      } else if(!this.menu && !this.showSchedules){
        if(press == "short"){
          if(button == "right"){
            this.increasePreSelectedDest();
          } else {
            this.decreasePreSelectedDest();
          }
        }else{
          if(this.destinationName != '')
            this.shearchInSchedule(this.destinationName);
        }
      } else if(!this.menu && this.showSchedules){
        if(press == "short" || press=="long"){
          this.goDestinationPage();
        }
      }
      
    },(error: any) => {
      this.websocketkiosk.reciveMessage();
    }
  )
  }

  increasePreSelectedDest(){
    //window.clearTimeout(this.timeOutToPlay);
    this.timeStopped=0;

    if(this.pagePreSelected != this.page){
      this.page = this.pagePreSelected;
      this.destinationStart=this.page*this.numberOfLines;
      this.trimDestinations();
    }

    if(this.preSelectedDestination+1 >= this.destinationList.length){
      this.preSelectedDestination=0;
      if(this.pagePreSelected+1 > this.numberOfPages){
        this.pagePreSelected++;
      }else{
        this.pagePreSelected=0;
      }
      this.increaseDestinationStart();
    } else {
      this.preSelectedDestination++;
    }
    
    //this.timeOutToPlay = setTimeout(() => {
      this.playSound("next", this.destinationList[this.preSelectedDestination].id);
    //}, this.timeToPlay)
    
    if(this.preSelectedDestination >= this.destinationStart + this.numberOfLines){

        this.pagePreSelected++;
        this.increaseDestinationStart();

    }

    this.destinationName=this.destinationList[this.preSelectedDestination].name;
  }

  decreasePreSelectedDest(){
    //window.clearTimeout(this.timeOutToPlay)
    this.timeStopped=0;

    if(this.pagePreSelected != this.page){
      this.page = this.pagePreSelected;
      this.destinationStart=this.page*this.numberOfLines;
      this.trimDestinations();
    }

    if(this.preSelectedDestination-1 < 0){
      this.preSelectedDestination = this.destinationList.length - 1;
      if(this.pagePreSelected - 1 < 0){
        this.pagePreSelected = this.numberOfPages-1;
      }else{
        this.pagePreSelected--;
      }
      this.decreaseDestinationStart();
    } else {
      this.preSelectedDestination--;
    }

    //this.timeOutToPlay = setTimeout(() => {
      this.playSound("next",this.destinationList[this.preSelectedDestination].id);
    //}, this.timeToPlay)

    if(this.preSelectedDestination < this.destinationStart){

        this.pagePreSelected--;
        this.decreaseDestinationStart();

    }

    this.destinationName=this.destinationList[this.preSelectedDestination].name;
  }

  playSound(pre_sound: string, sound: string){
    this.websocketkiosk.sendMessage({
      "type": "play",
      "pre_sound":pre_sound,
      "sound": sound,
      
    })
  }

  exitSchedule(){
    this.websocketkiosk.sendMessage({
      "type": "button",
      "press": "short",
      "gpio": 16,
      "kiosk_button": "left"
    })
  }

  isStopped(){
    if(this.timeStopped > 30){
      this.canExit = false;
      this.menu = true;
      this.preSelectedDestination = -1;
      this.destinationName = '';
      this.showSchedules = false;
      this.destinationList = [];
      this.destinationStart = 0;
      this.destinationListToShow = [];
      this.page = 0;
      this.pagePreSelected = 0;
    }
  }

  toggleFullStops(){
    this.timeStopped = this.menu ? 0 : 31;

    if(!this.production){
      if (this.full_stops == 'true') {
        this.full_stops = 'false';
      } else {
        this.full_stops = 'true';
      }
    }
  }

  getDestinations(){
    this.menu = false;
    this.destinationList = [];
    this.destinationStart = 0;
    this.destinationListToShow = [];
    
    if (this.full_stops != 'true') {

      this.api.getDestination(this.server).subscribe((data: any) => {
        data.forEach((element: any) => {
          this.menu = false;

          let destinations = {
            name: element.name,
            id: element.id,
          }

          this.destinationList.push(destinations);
        })

        this.trimDestinations();
        this.numberOfPages=Math.ceil(this.destinationList.length/this.numberOfLines);
      })

    } else {

      this.api.getDestinationStops().subscribe((data: any) => {

        let results = data.body.results;
        
        results.forEach((element: any) => {
          
          this.menu = false;

          let destinations = {
            name: element.stop_name.toUpperCase(),
            id: element.stop_id,
          }

          this.destinationList.push(destinations);
        })

        this.destinationList.sort((a: any, b: any) => a.name.localeCompare(b.name, 'pt', { sensitivity: 'base' }));        

        this.trimDestinations();
        this.numberOfPages=Math.ceil(this.destinationList.length/this.numberOfLines);
      })

    }
    
  }

  currentTime() {
    this.year = new Date().getFullYear()
    const FHour: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    };
    this.currentDate = new Date();

    this.hour = this.currentDate.toLocaleTimeString(undefined, FHour);
  }  

  showModal(){
    window.clearTimeout(this.timeoutModal);

    this.timeoutModal = setTimeout(() => {
        this.closeModal.nativeElement.click();
    }, this.timeoutModalTime);
  }

  increaseDestinationStart(){
    this.destinationName="";
    if(this.destinationStart + this.numberOfLines < this.destinationList.length){
      this.destinationStart += this.numberOfLines;
      this.page++;
      this.trimDestinations();
    }else{
      this.page=0;
      this.destinationStart = 0;
      this.trimDestinations();
    }

  }

  decreaseDestinationStart(){
    this.destinationName="";
    this.destinationStart -= this.numberOfLines;

    if(this.destinationStart + this.numberOfLines > 0){
      this.page--;
      this.trimDestinations();
    }else{
      this.page = this.numberOfPages -1;
      this.destinationStart = (this.numberOfPages -1)* this.numberOfLines;
      this.trimDestinations();
    }
  }

  trimDestinations(){
    this.destinationListToShow = this.destinationList.slice(this.destinationStart < 0 ? 0 : this.destinationStart , this.destinationStart + this.numberOfLines);
        this.timeStopped = 0;
        
  }

  iniSearch(){
    this.menu=false;
    this.getDestinations();
  }

  goDestinationPage(){
    if(this.canExit){
      this.playSound("next",this.destinationList[this.preSelectedDestination].id);
      this.destinationName=this.destinationList[this.preSelectedDestination].name;
      this.canExit = false;
      this.showSchedules = false;
      this.timeStopped = 0;
    }
  }

  shearchInSchedule(selectedDestination: String){

    for(var i = 0; i < this.destinationList.length; i++){
      if(this.destinationList[i].name == selectedDestination){
        this.preSelectedDestination = i; 
      }
    }

    let timeout = setTimeout(() => {
      this.canExit = true;
    }, 10000)

    this.destinationName="";
    this.pagePreSelected = this.page;
    this.selectedDestination = selectedDestination;
    this.timeStopped = 0;
    this.firstLines = [];
    this.lineList = [];

    this.api.getSchedule(this.server, undefined, undefined, '', selectedDestination)
      .subscribe((data: any)=> {

        if(data.total == 0){
          this.noSchedule = true;
          this.playSound("","destination_unavailable");
          clearTimeout(timeout);
          setTimeout(() => {
            this.canExit = true;
          }, 3000)
          return;
        };
        
        data.results.forEach((element: any, index: number) => {
          index
          let op = this.translations.find(op => op.id == element.id_operator);

          let opName = op != undefined ? op['operatorName'] : element.operator;

          let schedule= {
            line: element.line,
            operatorOriginal: element.operator,
            destination: element.line == '' ? element.destination : element.line + ' - ' + element.destination,
            observation: element.observation,
            operator: opName,
            time: element.time,
            platform: element.platform
          }

          if(index < this.numberOfFirstLines){
            this.firstLines.push(schedule)
          } else if(index <this.numberOfLinesSchedule+1){
            this.lineList.push(schedule)
          } 
      })

      this.playSound("confirm",this.firstLines[0].platform + "_" + this.firstLines[0].time);
      this.playSound("","kiosk_exit");

    },
    (errorSchedule: any) => {
      this.errorSchedule = true;
    }
  )
    this.showSchedules = true;
  }
  
  checkConection(){
    this.api.checkConection("kiosk").subscribe(
      (data:any)=>{
        this.conection=true
      },
      (error: any) => {
        this.conection=false
      }
    )
  }

  notifyKuma(){
    this.api.notifyKuma("kiosk").subscribe(
      (data:any)=>{
      },
      (error: any) => {
      }
    )
  }

  ngOnDestroy(){
    this.websocketkiosk.closeConnection();
  }

}
